export default __webpack_public_path__ + "static/media/6_1.cb28801f.png";